import { FormattedMessage, useIntl } from 'react-intl';

import { SectionHeader } from '@/components/SectionHeader';
import { Select } from '@/components/Select';
import { Typography } from '@/components/Typography';
import { messages as boutiqueMessages } from '@/messages/boutique';
import { formMessages } from '@/messages/forms';

import * as S from '../ContactUs.styles';
import { messages } from '../messages';
export type SelectOption = {
  label: string;
  value: string;
};
interface OfficialDistributorProps {
  defaultCountry: SelectOption | null;
  distributorInfo: {
    address: string;
    city: string;
    fax?: string;
    name: string;
    phone?: string;
  };
  distributorOptions: Array<{ label: string; value: string }>;
  handleCallBreitlingClick: (value: string) => void;
  handleDistributorChange: (value: SelectOption) => void;
  header: string | undefined | null;
}
export const OfficialDistributor: React.FC<OfficialDistributorProps> = ({
  defaultCountry,
  distributorInfo,
  distributorOptions,
  handleCallBreitlingClick,
  handleDistributorChange,
  header,
}) => {
  const { formatMessage } = useIntl();
  return (
    <S.Card>
      <SectionHeader
        colorized={false}
        data-test-id='ConfirmationViewSectionHeader'
        disableGutters
        sizeDesktop={32}
        sizeMobile={28}
        text={header ?? formatMessage(messages.officialDistributor)}
        textAlign='left'
      />
      <S.Section>
        {defaultCountry && (
          <S.SelectContainer>
            <Select
              defaultValue={defaultCountry}
              onChange={(opt) => {
                if (opt) {
                  handleDistributorChange(opt);
                }
              }}
              options={distributorOptions}
              variant='boxed'
            />
          </S.SelectContainer>
        )}
      </S.Section>
      <S.Contact>
        <Typography fontWeight='bold' scale='p2' textTransform='uppercase'>
          {distributorInfo.name}
        </Typography>
        <Typography scale='p2' textTransform='uppercase'>
          {distributorInfo.address}
        </Typography>
        <Typography scale='p2' textTransform='uppercase'>
          {distributorInfo.city}
        </Typography>
        {distributorInfo.phone && (
          <S.Pointer>
            <Typography
              onClick={() => handleCallBreitlingClick(distributorInfo.phone!)}
              scale='p2'
            >
              <FormattedMessage
                {...formMessages.findYourClosestBoutique}
              ></FormattedMessage>
              <S.Underline>{distributorInfo.phone}</S.Underline>
            </Typography>
          </S.Pointer>
        )}
        {distributorInfo.fax && (
          <Typography scale='p2'>
            <FormattedMessage {...boutiqueMessages.fax}></FormattedMessage>{' '}
            <S.Underline>{distributorInfo.fax}</S.Underline>
          </Typography>
        )}
      </S.Contact>
    </S.Card>
  );
};
